// Dark-only mode. Light theme removed by user decision (Feb 2026).
// All previous calls to applyTheme are no-ops that always enforce dark.

export const applyTheme = (_mode) => {
  document.documentElement.setAttribute("data-theme", "dark");
  localStorage.setItem("arabsanad-theme", "dark");
  window.dispatchEvent(new CustomEvent("themechange", { detail: { mode: "dark", effective: "dark" } }));
};

export const getTheme = () => "dark";
export const getEffectiveTheme = () => "dark";

export const initTheme = () => {
  document.documentElement.setAttribute("data-theme", "dark");
};
